import api from "./api";

export const getOpportunities = async (params = {}) => {
  const { data } = await api.get("/opportunities", { params });
  return data;
};

export const getOpportunitySummary = async (dateFrom, dateTo) => {
  const { data } = await api.get("/opportunities/summary", { params: { dateFrom, dateTo } });
  return data;
};

export const createOpportunity = async (opportunityData) => {
  console.log("[Opportunity] criando:", opportunityData);
  const { data } = await api.post("/opportunities", opportunityData);
  return data;
};

export const updateOpportunity = async (id, opportunityData) => {
  const { data } = await api.put(`/opportunities/${id}`, opportunityData);
  return data;
};

export const deleteOpportunity = async (id) => {
  const { data } = await api.delete(`/opportunities/${id}`);
  return data;
};

export const getOpportunityStages = async () => {
  const { data } = await api.get("/opportunities/stages");
  return data;
};

export const getKanbanVisualConfig = async () => {
  const { data } = await api.get("/opportunities/kanban-visual");
  return data;
};

export const saveKanbanVisualConfig = async (payload) => {
  const { data } = await api.put("/opportunities/kanban-visual", payload);
  return data;
};

export const createKanbanStage = async (payload) => {
  const { data } = await api.post("/opportunities/stages", payload);
  return data;
};

export const deleteKanbanStage = async (stageId) => {
  const { data } = await api.delete(`/opportunities/stages/${stageId}`);
  return data;
};


